import { useEffect } from "react";
import { Printer, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PROCESSING_ACTIVITIES = [
  {
    nr: "1",
    titel: "Kundenanfragen über die Website",
    zweck:
      "Bearbeitung von Anfragen über Kontakt- und Schätzungs-Formulare; Vertragsanbahnung",
    rechtsgrundlage: "Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)",
    kategorien: "Interessenten / Website-Besucher",
    daten:
      "Name, E-Mail, Telefon (optional), Anliegen, Nachrichteninhalte; bei Schätzung: Objektart, Größe, Ort",
    empfaenger:
      "Emergent Labs Inc. (Hosting), Resend / Plus Five Five, Inc. (E-Mail-Versand), IONOS SE (Posteingang)",
    drittland:
      "USA (Emergent, Resend) — abgesichert über EU-Standardvertragsklauseln und EU-US Data Privacy Framework",
    loeschfrist:
      "Datenbank: 14 Tage (automatischer TTL); E-Mail-Postfach: bis Zweck entfällt, max. 24 Monate",
    tom:
      "TLS-Verschlüsselung, Zugriff nur durch Inhaber, Passwortschutz Postfach & Geräte, regelmäßige Updates",
  },
  {
    nr: "2",
    titel: "Immobilienvermittlung & Maklertätigkeit",
    zweck:
      "Anbahnung, Abschluss und Durchführung von Maklerverträgen; Vermittlung von Kauf-, Verkaufs- und Mietverträgen",
    rechtsgrundlage:
      "Art. 6 Abs. 1 lit. b DSGVO (Vertragsdurchführung); Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Pflichten, GwG, MaBV)",
    kategorien: "Auftraggeber, Kauf-/Mietinteressenten, Eigentümer",
    daten:
      "Stammdaten (Name, Anschrift, Geburtsdatum), Kontaktdaten, Ausweisdaten (GwG), Bonitäts-/Einkommensdaten, Objektdaten",
    empfaenger:
      "Notare, Käufer/Verkäufer, ggf. Behörden (Finanzamt, Aufsichtsbehörde), Lexware Office",
    drittland: "Keine Drittlandsübermittlung",
    loeschfrist:
      "Vertragsunterlagen: 10 Jahre (§ 147 AO, § 257 HGB); GwG-Unterlagen: 5 Jahre (§ 8 GwG)",
    tom:
      "Verschlüsselte Datenträger, Aktenschrank abschließbar, Zugriff nur durch Inhaber",
  },
  {
    nr: "3",
    titel: "Objektbetreuung, Pflege & Instandhaltung",
    zweck:
      "Erbringung handwerklicher und pflegerischer Dienstleistungen an Immobilien der Auftraggeber",
    rechtsgrundlage: "Art. 6 Abs. 1 lit. b DSGVO (Vertragsdurchführung)",
    kategorien: "Auftraggeber, ggf. Mieter (für Terminabsprache)",
    daten:
      "Name, Anschrift, Kontaktdaten, Objektdaten, Schlüsselverwaltung, Leistungsbeschreibung",
    empfaenger: "Lexware Office (Abrechnung), ggf. Subunternehmer / Handwerker",
    drittland: "Keine",
    loeschfrist:
      "Vertrags- und Rechnungsunterlagen: 10 Jahre (§ 147 AO, § 257 HGB)",
    tom: "Zugriff nur durch Inhaber, abschließbarer Aktenschrank, Schlüsselprotokoll",
  },
  {
    nr: "4",
    titel: "Buchhaltung & Rechnungsstellung",
    zweck: "Ordnungsgemäße Buchführung und Rechnungsstellung",
    rechtsgrundlage:
      "Art. 6 Abs. 1 lit. c DSGVO i.V.m. §§ 140, 147 AO und § 257 HGB",
    kategorien: "Kunden, Auftraggeber, Lieferanten",
    daten:
      "Stammdaten, Rechnungsdaten, Zahlungsdaten, ggf. Steuerinformationen",
    empfaenger:
      "Lexware Office / Haufe Service Center GmbH, Steuerberater, Finanzbehörden",
    drittland: "Keine",
    loeschfrist: "10 Jahre (§ 147 AO)",
    tom:
      "Zugriffsschutz Lexware-Konto (2FA), verschlüsselte Datenübertragung",
  },
  {
    nr: "5",
    titel: "Terminverwaltung (Besichtigungen, Kundentermine)",
    zweck: "Organisation und Verwaltung von Terminen mit Kunden und Interessenten",
    rechtsgrundlage: "Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung/-durchführung)",
    kategorien: "Kunden, Interessenten",
    daten:
      "Name, Telefon, Objektadresse, Terminzeit, ggf. Notizen",
    empfaenger:
      "Google Ireland Limited (Google Calendar) bzw. Apple Distribution International Ltd. (iCloud)",
    drittland:
      "USA — abgesichert über EU-US Data Privacy Framework / Standardvertragsklauseln",
    loeschfrist: "Bis zur Erledigung des Termins + ca. 6 Monate für Nachvollziehbarkeit",
    tom:
      "Zugriffsschutz via Apple-ID / Google-Konto mit 2-Faktor-Authentifizierung, Gerätesperre",
  },
  {
    nr: "6",
    titel: "E-Mail-Kommunikation",
    zweck:
      "Allgemeiner Schriftverkehr mit Kunden, Interessenten, Behörden und Geschäftspartnern",
    rechtsgrundlage:
      "Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. f DSGVO (Geschäftskommunikation)",
    kategorien: "Kunden, Interessenten, Geschäftspartner, Behörden",
    daten: "Name, E-Mail-Adresse, Inhalte der Korrespondenz",
    empfaenger: "1&1 IONOS SE (E-Mail-Hosting)",
    drittland: "Keine (IONOS in Deutschland)",
    loeschfrist:
      "Geschäftsrelevante E-Mails: 6–10 Jahre gemäß HGB/AO; Übrige: bei Wegfall des Zwecks",
    tom: "TLS-Übertragung, Passwortschutz Postfach, Spam-/Phishing-Filter IONOS",
  },
  {
    nr: "7",
    titel: "Erstellung von Exposés und Dokumenten",
    zweck:
      "Erstellung von Immobilien-Exposés, Notizen, Kalkulationen, Verträgen",
    rechtsgrundlage:
      "Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. f DSGVO",
    kategorien: "Eigentümer, Interessenten",
    daten: "Objektdaten, ggf. Eigentümer- und Interessentendaten, Fotos",
    empfaenger:
      "Apple Distribution International Ltd. (iCloud-Sync Pages/Numbers)",
    drittland:
      "USA möglich — abgesichert über EU-US Data Privacy Framework",
    loeschfrist:
      "Bis Vertragsende + gesetzliche Aufbewahrungsfristen (10 Jahre)",
    tom: "Apple-ID mit 2FA, Geräteverschlüsselung, lokale Sicherung",
  },
];

const TOMS = [
  "Geräte mit Passwort/Touch-ID/Face-ID geschützt; automatische Sperre",
  "Festplatten-/Geräteverschlüsselung aktiv (FileVault, iOS-Geräteverschlüsselung)",
  "Regelmäßige Software-Updates auf allen Geräten",
  "Aktuelles Anti-Viren-Programm bzw. macOS-Bordmittel",
  "Starke Passwörter, wo möglich 2-Faktor-Authentifizierung (Apple-ID, Lexware, Google, Resend, Emergent, IONOS)",
  "TLS-/SSL-Verschlüsselung bei Datenübertragung im Internet (HTTPS)",
  "Trennung privater und beruflicher Daten",
  "Physische Sicherung: abschließbare Räume, Aktenschränke, sichere Schlüsselverwaltung",
  "Sichere Entsorgung von Papierdokumenten (Schredder) und elektronischen Speichermedien",
  "Regelmäßige Backups (iCloud / Lexware Cloud)",
  "Sensibilisierung des Inhabers (regelmäßiges Selbst-Update zu aktuellen Datenschutzthemen)",
];

export default function VVT() {
  useEffect(() => {
    document.title =
      "Verzeichnis von Verarbeitungstätigkeiten – Rosenberg Objektservice";
  }, []);

  return (
    <div className="bg-white min-h-screen text-[#0A0A0A] print:bg-white">
      {/* Toolbar — hidden when printing */}
      <div className="print:hidden border-b border-neutral-200 sticky top-0 bg-white z-10">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-wider font-semibold text-[#0A0A0A] hover:text-[#8A151B] transition-colors"
          >
            <ArrowLeft size={16} />
            Zurück
          </Link>
          <div className="flex items-center gap-3">
            <p className="hidden sm:block text-xs text-neutral-500 italic">
              Tipp: über „Drucken → Als PDF speichern" sichern und ablegen
            </p>
            <button
              onClick={() => window.print()}
              data-testid="vvt-print-button"
              className="inline-flex items-center gap-2 bg-[#8A151B] text-white hover:bg-[#6B1015] px-5 py-2.5 font-semibold tracking-wide transition-colors uppercase text-sm"
            >
              <Printer size={16} />
              Drucken / als PDF speichern
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10 print:py-4 print:px-0">
        {/* Header */}
        <div className="border-b-2 border-[#0A0A0A] pb-6 mb-8">
          <p className="text-xs uppercase tracking-[0.3em] font-bold text-[#8A151B]">
            Art. 30 Abs. 1 DSGVO
          </p>
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-2">
            Verzeichnis von Verarbeitungstätigkeiten
          </h1>
          <p className="mt-2 text-sm text-neutral-500">
            Rosenberg Objektservice · Stand:{" "}
            {new Date().toLocaleDateString("de-DE", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            })}
          </p>
        </div>

        {/* Verantwortlicher */}
        <section className="mb-10 page-section">
          <h2 className="font-display text-xl font-bold uppercase tracking-wider mb-4">
            A. Verantwortlicher
          </h2>
          <table className="w-full text-sm border border-neutral-300">
            <tbody>
              {[
                ["Name / Firma", "Marc Rosenberg – Rosenberg Objektservice"],
                ["Anschrift", "Weserstraße 3, 63322 Rödermark"],
                ["Telefon", "0155 62376061"],
                ["E-Mail", "info@rosenberg-objektservice.de"],
                ["Tätigkeit", "Immobilienvermittlung, Objektbetreuung, Instandhaltung, Pflege"],
                ["Datenschutzbeauftragter", "Nicht erforderlich (< 20 Personen verarbeiten regelmäßig personenbezogene Daten); Verantwortung beim Inhaber"],
              ].map(([k, v]) => (
                <tr key={k} className="border-b border-neutral-200 last:border-b-0">
                  <td className="bg-neutral-50 font-semibold px-4 py-3 w-[35%] align-top">
                    {k}
                  </td>
                  <td className="px-4 py-3 align-top">{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {/* Verarbeitungstätigkeiten */}
        <section className="mb-10">
          <h2 className="font-display text-xl font-bold uppercase tracking-wider mb-4">
            B. Verarbeitungstätigkeiten
          </h2>

          <div className="space-y-8 print:space-y-6">
            {PROCESSING_ACTIVITIES.map((act) => (
              <div
                key={act.nr}
                className="border border-neutral-300 print:break-inside-avoid page-section"
              >
                <div className="bg-[#0A0A0A] text-white px-4 py-3 flex items-center gap-3">
                  <span className="text-xs uppercase tracking-widest opacity-60">
                    Nr.
                  </span>
                  <span className="font-display text-2xl font-bold">
                    {act.nr}
                  </span>
                  <span className="font-display text-lg font-semibold ml-2">
                    {act.titel}
                  </span>
                </div>
                <table className="w-full text-sm">
                  <tbody>
                    {[
                      ["Zweck", act.zweck],
                      ["Rechtsgrundlage", act.rechtsgrundlage],
                      ["Kategorien betroffener Personen", act.kategorien],
                      ["Kategorien personenbezogener Daten", act.daten],
                      ["Empfänger / Auftragsverarbeiter", act.empfaenger],
                      ["Drittlandsübermittlung", act.drittland],
                      ["Löschfristen", act.loeschfrist],
                      ["Technische & organisatorische Maßnahmen", act.tom],
                    ].map(([k, v]) => (
                      <tr
                        key={k}
                        className="border-b border-neutral-200 last:border-b-0"
                      >
                        <td className="bg-neutral-50 font-semibold px-4 py-2.5 w-[35%] align-top">
                          {k}
                        </td>
                        <td className="px-4 py-2.5 align-top">{v}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </section>

        {/* TOMs */}
        <section className="mb-10 page-section">
          <h2 className="font-display text-xl font-bold uppercase tracking-wider mb-4">
            C. Allgemeine technische & organisatorische Maßnahmen (Art. 32 DSGVO)
          </h2>
          <div className="border border-neutral-300 p-6">
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed">
              {TOMS.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* Auftragsverarbeiter Übersicht */}
        <section className="mb-10 page-section">
          <h2 className="font-display text-xl font-bold uppercase tracking-wider mb-4">
            D. Übersicht Auftragsverarbeiter & AVV-Status
          </h2>
          <table className="w-full text-sm border border-neutral-300">
            <thead>
              <tr className="bg-neutral-100">
                <th className="text-left px-4 py-2.5 font-semibold border-b border-neutral-300">
                  Anbieter
                </th>
                <th className="text-left px-4 py-2.5 font-semibold border-b border-neutral-300">
                  Zweck
                </th>
                <th className="text-left px-4 py-2.5 font-semibold border-b border-neutral-300">
                  Sitz
                </th>
                <th className="text-left px-4 py-2.5 font-semibold border-b border-neutral-300">
                  AVV vorhanden
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1&1 IONOS SE", "E-Mail-Hosting, Domain", "Deutschland", "Ja (Standard-AVV IONOS)"],
                ["Haufe Service Center GmbH (Lexware Office)", "Buchhaltung & CRM", "Deutschland", "Im Konto zu akzeptieren"],
                ["Resend / Plus Five Five, Inc.", "Transaktions-E-Mail", "USA", "Ja (online-DPA, DPF-zertifiziert)"],
                ["Emergent Labs Inc.", "Website-Hosting & Datenbank", "USA", "Beim Support anfragen"],
                ["Apple Distribution International Ltd.", "iCloud Sync Pages/Numbers", "Irland / USA", "iCloud-AGB / Business-AGB"],
                ["Google Ireland Limited", "Kalender (nur falls genutzt)", "Irland / USA", "Workspace-AVV (nur Workspace-Konten)"],
              ].map((row) => (
                <tr key={row[0]} className="border-b border-neutral-200 last:border-b-0">
                  {row.map((cell, i) => (
                    <td key={i} className="px-4 py-2.5 align-top">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {/* Signatur */}
        <section className="mt-16 print:mt-12">
          <div className="grid grid-cols-2 gap-12 print:gap-8">
            <div>
              <div className="border-b border-neutral-400 h-12 mb-2"></div>
              <p className="text-xs text-neutral-600">
                Ort, Datum
              </p>
            </div>
            <div>
              <div className="border-b border-neutral-400 h-12 mb-2"></div>
              <p className="text-xs text-neutral-600">
                Unterschrift Marc Rosenberg
              </p>
            </div>
          </div>
        </section>

        <p className="mt-12 text-xs text-neutral-500 italic leading-relaxed">
          Hinweis: Dieses Verzeichnis dient als Muster auf Basis der von Ihnen
          mitgeteilten Tätigkeiten und ist regelmäßig (z.B. einmal jährlich
          oder bei Änderungen) zu prüfen und bei Bedarf anzupassen. Bei
          spezifischen rechtlichen Fragen empfiehlt sich die Konsultation
          eines Datenschutzberaters oder Fachanwalts.
        </p>
      </div>

      <style>{`
        @media print {
          @page { size: A4; margin: 18mm; }
          .page-section { page-break-inside: avoid; }
          a { color: inherit; text-decoration: none; }
        }
      `}</style>
    </div>
  );
}
